import { useState } from "react";
import axios from "axios";
import CrmDashboard from "./CrmDashboard";
import CrmLeads from "./CrmLeads";
import CrmLeadProfile from "./CrmLeadProfile";
import CrmAddLead from "./CrmAddLead";
import CrmEditLead from "./CrmEditLead";
import CrmCallingPanel from "./CrmCallingPanel";
import CrmManageUsers from "./CrmManageUsers";
import CrmFollowups from "./CrmFollowups";
import CrmBulkUpload from "./CrmBulkUpload";

const CRM_BASE = "https://crm.smartscholars360.com";

const NAV_ITEMS = [
  { key: "crm-dashboard", icon: "bi-speedometer2", label: "Dashboard" },
  { key: "crm-leads", icon: "bi-people-fill", label: "Leads" },
  { key: "crm-calling", icon: "bi-telephone-fill", label: "Calling Panel" },
  { key: "crm-followups", icon: "bi-calendar-check-fill", label: "Follow-ups" },
  { key: "crm-bulk-upload", icon: "bi-cloud-upload-fill", label: "Bulk Upload", adminOnly: true },
  { key: "crm-manage-users", icon: "bi-person-badge-fill", label: "Employees", adminOnly: true },
];

// ── Login Page ──────────────────────────────────────────────────────────────
function CrmLoginPage({ onLogin }) {
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPwd, setShowPwd] = useState(false);

  const inputStyle = {
    width: "100%", padding: "12px 16px",
    background: "rgba(255,255,255,.08)",
    border: "1.5px solid rgba(255,255,255,.12)",
    borderRadius: "12px", color: "#fff",
    fontSize: "14px", outline: "none", boxSizing: "border-box",
  };
  const labelStyle = {
    color: "rgba(255,255,255,.65)", fontSize: "11px", fontWeight: 700,
    textTransform: "uppercase", letterSpacing: "0.7px",
    marginBottom: "8px", display: "block",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await axios.post(`${CRM_BASE}/users/login`, null, {
        params: { username: mobile, password },
      });
      const { access_token, user, role, user_id } = res.data;
      localStorage.setItem("crm_token", access_token);
      localStorage.setItem("crm_user", user);
      localStorage.setItem("crm_role", role);
      localStorage.setItem("crm_user_id", user_id);
      onLogin();
    } catch {
      setError("Invalid credentials. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #1a1869 100%)",
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: "20px", fontFamily: "'Inter', system-ui, sans-serif",
      position: "relative", overflow: "hidden",
    }}>
      {/* Decorative orbs */}
      <div style={{ position: "fixed", top: "8%", left: "3%", width: 350, height: 350, borderRadius: "50%", background: "rgba(43,39,234,.18)", filter: "blur(90px)", pointerEvents: "none" }} />
      <div style={{ position: "fixed", bottom: "12%", right: "6%", width: 280, height: 280, borderRadius: "50%", background: "rgba(6,158,230,.14)", filter: "blur(75px)", pointerEvents: "none" }} />
      <div style={{ position: "fixed", top: "45%", right: "20%", width: 180, height: 180, borderRadius: "50%", background: "rgba(168,85,247,.1)", filter: "blur(60px)", pointerEvents: "none" }} />

      <div style={{
        background: "rgba(255,255,255,.07)",
        backdropFilter: "blur(24px)",
        border: "1px solid rgba(255,255,255,.13)",
        borderRadius: "28px",
        padding: "52px 44px",
        width: "100%", maxWidth: "420px",
        position: "relative", zIndex: 1,
        boxShadow: "0 32px 80px rgba(0,0,0,.4)",
      }}>
        {/* Brand */}
        <div style={{ textAlign: "center", marginBottom: "40px" }}>
          <div style={{
            width: 68, height: 68,
            background: "linear-gradient(135deg, #2b27ea, #069ee6)",
            borderRadius: "20px",
            display: "inline-flex", alignItems: "center", justifyContent: "center",
            marginBottom: "18px",
            boxShadow: "0 10px 40px rgba(43,39,234,.45)",
          }}>
            <i className="bi bi-diagram-3-fill" style={{ fontSize: "30px", color: "#fff" }}></i>
          </div>
          <h3 style={{ color: "#fff", fontWeight: 800, margin: "0 0 6px", fontSize: "22px", letterSpacing: "-0.3px" }}>
            Smart Scholar 360
          </h3>
          <p style={{ color: "rgba(255,255,255,.45)", fontSize: "13px", margin: 0 }}>
            CRM Portal &mdash; Counsellor Access
          </p>
        </div>

        {error && (
          <div style={{
            background: "rgba(220,38,38,.15)",
            border: "1px solid rgba(220,38,38,.3)",
            borderRadius: "10px", padding: "10px 14px",
            color: "#fca5a5", fontSize: "13px", marginBottom: "20px",
          }}>
            <i className="bi bi-exclamation-circle me-2"></i>{error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "16px" }}>
            <label style={labelStyle}>Mobile Number</label>
            <input
              type="text" value={mobile} onChange={e => setMobile(e.target.value)}
              placeholder="Enter your mobile number" required style={inputStyle}
            />
          </div>
          <div style={{ marginBottom: "30px" }}>
            <label style={labelStyle}>Password</label>
            <div style={{ position: "relative" }}>
              <input
                type={showPwd ? "text" : "password"} value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Enter your password" required
                style={{ ...inputStyle, paddingRight: "48px" }}
              />
              <button
                type="button" onClick={() => setShowPwd(!showPwd)}
                style={{
                  position: "absolute", right: "14px", top: "50%", transform: "translateY(-50%)",
                  background: "none", border: "none", color: "rgba(255,255,255,.45)", cursor: "pointer", padding: 0,
                }}
              >
                <i className={`bi bi-eye${showPwd ? "-slash" : ""}`}></i>
              </button>
            </div>
          </div>
          <button
            type="submit" disabled={loading}
            style={{
              width: "100%", padding: "13px",
              background: loading ? "rgba(43,39,234,.45)" : "linear-gradient(135deg, #2b27ea, #069ee6)",
              border: "none", borderRadius: "12px", color: "#fff",
              fontSize: "15px", fontWeight: 700,
              cursor: loading ? "not-allowed" : "pointer",
              boxShadow: "0 4px 24px rgba(43,39,234,.45)",
              display: "flex", alignItems: "center", justifyContent: "center", gap: "8px",
              transition: "opacity .15s ease",
            }}
          >
            {loading
              ? <><span className="spinner-border spinner-border-sm"></span> Signing in...</>
              : <><i className="bi bi-box-arrow-in-right"></i> Sign In to CRM</>
            }
          </button>
        </form>

        <p style={{ color: "rgba(255,255,255,.25)", fontSize: "11px", textAlign: "center", marginTop: "32px", marginBottom: 0 }}>
          Smart Scholar 360 &copy; {new Date().getFullYear()} &mdash; Lead Management System
        </p>
      </div>
    </div>
  );
}

// ── CRM Portal (after login) ────────────────────────────────────────────────
export default function CrmPortal() {
  const [loggedIn, setLoggedIn] = useState(!!localStorage.getItem("crm_token"));
  const [view, setView] = useState("crm-dashboard");
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const crmRole = localStorage.getItem("crm_role");
  const crmUser = localStorage.getItem("crm_user");

  const navigate = (target, leadId = null) => {
    setSelectedLeadId(leadId);
    setView(target);
  };

  const logout = () => {
    ["crm_token", "crm_user", "crm_role", "crm_user_id"].forEach(k => localStorage.removeItem(k));
    setLoggedIn(false);
    setView("crm-dashboard");
  };

  if (!loggedIn) {
    return <CrmLoginPage onLogin={() => setLoggedIn(true)} />;
  }

  const activeTab =
    ["crm-lead-profile", "crm-add-lead", "crm-edit-lead"].includes(view)
      ? "crm-leads"
      : view;

  const renderView = () => {
    switch (view) {
      case "crm-dashboard":
        return <CrmDashboard onNavigate={navigate} />;
      case "crm-leads":
        return <CrmLeads onNavigate={navigate} />;
      case "crm-lead-profile":
        return <CrmLeadProfile leadId={selectedLeadId} onBack={() => navigate("crm-leads")} onNavigate={navigate} />;
      case "crm-add-lead":
        return <CrmAddLead onBack={() => navigate("crm-leads")} />;
      case "crm-edit-lead":
        return <CrmEditLead leadId={selectedLeadId} onBack={() => navigate("crm-leads")} />;
      case "crm-calling":
        return <CrmCallingPanel onNavigate={navigate} />;
      case "crm-manage-users":
        return <CrmManageUsers />;
      case "crm-followups":
        return <CrmFollowups onNavigate={navigate} />;
      case "crm-bulk-upload":
        return <CrmBulkUpload />;
      default:
        return <CrmDashboard onNavigate={navigate} />;
    }
  };

  const SW = sidebarOpen ? 240 : 66;
  const activeLabel = NAV_ITEMS.find(t => t.key === activeTab)?.label || "CRM";

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#f0f4ff", fontFamily: "'Inter', system-ui, sans-serif" }}>

      {/* ── Sidebar ─────────────────────────────────────── */}
      <aside style={{
        width: SW, minHeight: "100vh",
        background: "linear-gradient(180deg, #1a1869 0%, #0e2a4a 100%)",
        display: "flex", flexDirection: "column", flexShrink: 0,
        transition: "width .25s ease", overflow: "hidden",
        position: "fixed", top: 0, left: 0, bottom: 0, zIndex: 100,
        boxShadow: "4px 0 24px rgba(0,0,0,.18)",
      }}>

        {/* Logo */}
        <div style={{ padding: "20px 14px 18px", borderBottom: "1px solid rgba(255,255,255,.08)" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div style={{
              width: 38, height: 38, borderRadius: "11px", flexShrink: 0,
              background: "linear-gradient(135deg, #2b27ea, #069ee6)",
              display: "flex", alignItems: "center", justifyContent: "center",
              boxShadow: "0 4px 12px rgba(43,39,234,.4)",
            }}>
              <i className="bi bi-diagram-3-fill" style={{ color: "#fff", fontSize: "17px" }}></i>
            </div>
            {sidebarOpen && (
              <div>
                <div style={{ color: "#fff", fontWeight: 800, fontSize: "13px", lineHeight: 1.2 }}>Smart Scholar</div>
                <div style={{ color: "rgba(255,255,255,.38)", fontSize: "10px", letterSpacing: "0.4px" }}>CRM Portal</div>
              </div>
            )}
          </div>
        </div>

        {/* Nav */}
        <nav style={{ flex: 1, padding: "14px 8px", overflowY: "auto" }}>
          {NAV_ITEMS.filter(t => !t.adminOnly || crmRole === "admin").map(item => {
            const active = activeTab === item.key;
            return (
              <button
                key={item.key}
                onClick={() => navigate(item.key)}
                style={{
                  width: "100%",
                  display: "flex", alignItems: "center",
                  gap: "10px",
                  padding: sidebarOpen ? "10px 14px" : "11px",
                  justifyContent: sidebarOpen ? "flex-start" : "center",
                  borderRadius: "10px",
                  border: "none",
                  background: active ? "rgba(255,255,255,.13)" : "transparent",
                  color: active ? "#fff" : "rgba(255,255,255,.5)",
                  cursor: "pointer",
                  marginBottom: "3px",
                  fontWeight: active ? 700 : 500,
                  fontSize: "13px",
                  transition: "all .15s ease",
                  borderLeft: active ? "3px solid #069ee6" : "3px solid transparent",
                }}
              >
                <i className={`bi ${item.icon}`} style={{ fontSize: "16px", flexShrink: 0 }}></i>
                {sidebarOpen && <span>{item.label}</span>}
              </button>
            );
          })}
        </nav>

        {/* User + Logout */}
        <div style={{ padding: sidebarOpen ? "14px 16px 22px" : "10px 8px 18px", borderTop: "1px solid rgba(255,255,255,.08)" }}>
          {sidebarOpen ? (
            <>
              <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
                <div style={{
                  width: 34, height: 34, borderRadius: "50%", flexShrink: 0,
                  background: "linear-gradient(135deg,#2b27ea,#069ee6)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                }}>
                  <i className="bi bi-person-fill" style={{ color: "#fff", fontSize: "15px" }}></i>
                </div>
                <div>
                  <div style={{ color: "#fff", fontSize: "12px", fontWeight: 700 }}>{crmUser}</div>
                  <div style={{ color: "rgba(255,255,255,.38)", fontSize: "10px", textTransform: "capitalize" }}>{crmRole}</div>
                </div>
              </div>
              <button
                onClick={logout}
                style={{
                  width: "100%", padding: "8px",
                  border: "1px solid rgba(220,38,38,.4)",
                  borderRadius: "9px", background: "rgba(220,38,38,.12)",
                  color: "#fca5a5", fontSize: "12px", fontWeight: 600,
                  cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: "6px",
                }}
              >
                <i className="bi bi-box-arrow-right"></i> Logout
              </button>
            </>
          ) : (
            <button
              onClick={logout}
              title="Logout"
              style={{
                width: "100%", padding: "10px", border: "none",
                borderRadius: "9px", background: "rgba(220,38,38,.15)",
                color: "#fca5a5", cursor: "pointer",
              }}
            >
              <i className="bi bi-box-arrow-right"></i>
            </button>
          )}
        </div>

        {/* Collapse toggle */}
        <button
          onClick={() => setSidebarOpen(!sidebarOpen)}
          style={{
            position: "absolute", top: "50%", right: "-13px",
            transform: "translateY(-50%)",
            width: 26, height: 26, borderRadius: "50%",
            background: "linear-gradient(135deg,#2b27ea,#069ee6)",
            border: "2.5px solid #f0f4ff",
            color: "#fff", fontSize: "10px", cursor: "pointer",
            display: "flex", alignItems: "center", justifyContent: "center",
            boxShadow: "0 2px 8px rgba(43,39,234,.4)",
            zIndex: 101,
          }}
        >
          <i className={`bi bi-chevron-${sidebarOpen ? "left" : "right"}`}></i>
        </button>
      </aside>

      {/* ── Main ────────────────────────────────────────── */}
      <main style={{ flex: 1, marginLeft: SW, transition: "margin-left .25s ease", display: "flex", flexDirection: "column", minHeight: "100vh" }}>

        {/* Top bar */}
        <header style={{
          height: 62,
          background: "#fff",
          borderBottom: "1px solid #e5e7eb",
          display: "flex", alignItems: "center", justifyContent: "space-between",
          padding: "0 28px",
          position: "sticky", top: 0, zIndex: 50,
          boxShadow: "0 2px 10px rgba(0,0,0,.05)",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div style={{ width: 3, height: 22, borderRadius: 99, background: "linear-gradient(180deg,#2b27ea,#069ee6)" }} />
            <h6 style={{ margin: 0, fontWeight: 800, color: "#111827", fontSize: "16px" }}>{activeLabel}</h6>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#22c55e", boxShadow: "0 0 0 3px rgba(34,197,94,.2)" }} />
            <span style={{ fontSize: "12px", color: "#6b7280", fontWeight: 500 }}>System Live</span>
          </div>
        </header>

        {/* Content */}
        <div style={{ flex: 1, padding: "28px 32px" }}>
          {renderView()}
        </div>
      </main>
    </div>
  );
}
